import type {
    OptimisationInputs,
    OptimizedPlan,
} from '@/dashboards/shared/optimisation/optimisationSession';
import { lockedVariables } from '@/dashboards/shared/optimisation/optimiserRun';
import { DashboardRule, optimizerServiceManager } from '@/optimizer';
import { withOptimizerTimeout } from '@/optimizer/helpers/withOptimizerTimeout';

// Yearly plans solve over a longer horizon than a campaign, so the budget screen gets 90 s
// instead of the shared 60 s plan timeout.
export const BUDGET_OPTIMIZATION_TIMEOUT_MS = 90_000;

const appliesToBudget = (rule: DashboardRule) =>
    rule.target === 'all' || rule.target === 'budget';

export const runBudgetOptimisation = async ({
    inputs,
    rules,
}: {
    inputs: OptimisationInputs;
    rules: DashboardRule[];
}): Promise<OptimizedPlan> => {
    if (!optimizerServiceManager) {
        throw new Error('Optimizer is not initialized');
    }

    return withOptimizerTimeout(
        optimizerServiceManager.serviceManager.getOptimizedPlan({
            budget: inputs.budget,
            optimizationBase: inputs.optimizationBase,
            startDate: inputs.startDate,
            endDate: inputs.endDate,
            variables: lockedVariables(inputs),
            configRules: rules.filter(appliesToBudget),
        }),
        'Budget optimization',
        BUDGET_OPTIMIZATION_TIMEOUT_MS,
    );
};
